<template>
    <LeftSidebar v-if="!appData.isMobile">
        <li class="nav-link" v-for="r in pc" :key="r">
            <router-link
                :to="Links.Url(r.link, r.args)"
                :title="r.text"
                :class="[isSelectUrl(Links.Url(r.link, r.args)) ? 'active' : '']"
            >
                <span class="menu-icon" aria-hidden="true">
                    <svg v-if="r.key === 'dashboard'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="7" height="7" x="3" y="3" rx="1"/>
                        <rect width="7" height="7" x="14" y="3" rx="1"/>
                        <rect width="7" height="7" x="14" y="14" rx="1"/>
                        <rect width="7" height="7" x="3" y="14" rx="1"/>
                    </svg>

                    <svg v-else-if="r.key === 'appointments'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                        <path d="M16 3.128a4 4 0 0 1 0 7.744"/>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                        <circle cx="9" cy="7" r="4"/>
                    </svg>

                    <svg v-else-if="r.key === 'documents'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/>
                        <path d="M14 2v5a1 1 0 0 0 1 1h5"/>
                        <path d="M10 9H8"/>
                        <path d="M16 13H8"/>
                        <path d="M16 17H8"/>
                    </svg>

                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.925 20.056a6 6 0 0 0-11.851.001"/>
                        <circle cx="12" cy="11" r="4"/>
                        <circle cx="12" cy="12" r="10"/>
                    </svg>
                </span>
                <span class="link-name">{{r.text}}</span>
            </router-link>
        </li>
    </LeftSidebar>

    <LeftSidebarMobile v-else
        :items="[{ link: Links.Dashboard, text: 'Panelim', icon: 'icon-dashboard' }, ...instructorMobileItems]"
        :isActive="isSelectUrl" />
</template>

<script>
import { reactive, toRefs, computed } from "vue";

    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";

    import LeftSidebar from "@/layouts/_partials/LeftSidebar.vue";
    
    import LeftSidebarMobile from "@/layouts/_partials/LeftSidebar.mobile.vue";
    import { useRoute } from "vue-router";

    export default {
        props: ["type"],

        components: {
            LeftSidebar,
            LeftSidebarMobile,
        },

        setup(props) {
            const route = useRoute();
            const e = reactive({
                isSelectUrl(link) {
                    if (C.Str(route.path) == link) {
                    return true;
                }

                    return C.Str(route.path).indexOf(link.replace(/\/0/g, "")) == 0;
                },

                pc: computed(() => {
                    switch (props.type) {
                        case Enums.MENU_TYPE.DOCUMENT:
                            return [
                            {
                                key: "dashboard",
                                icon: "icon-dashboard",
                                link: Links.Dashboard,
                                text: "Panelim",
                            },
                            {
                                key: "documents",
                                icon: "icon-folderbag",
                                link: Links.Document.PublicList,
                                text: "Genel",
                            },
                            ];

                        case Enums.MENU_TYPE.MAIN:
                        default:
                            return [
                            {
                                key: "dashboard",
                                icon: "icon-dashboard",
                                link: Links.Dashboard,
                                text: "Panelim",
                            },
                            {
                                key: "appointments",
                                icon: "icon-meeting",
                                link: Links.Appointment.List,
                                text: "Görüşmelerim",
                            },
                            {
                                key: "documents",
                                icon: "icon-books-list",
                                link: Links.Document.PublicList,
                                text: "Dokümanlarım",
                            },
                            {
                                key: "profile",
                                icon: "icon-user",
                                link: Links.User.Profile,
                                text: "Profilim",
                            },
                            ];
                    }
                }),

            instructorMobileItems: computed(() => {
                            return [
                    {
                        key: "appointments",
                        link: Links.Appointment.List,
                        text: "Görüşmelerim",
                    },
                    {
                        key: "documents",
                        link: Links.Document.PublicList,
                        text: "Dokümanlarım",
                    },
                    {
                        key: "profile",
                        link: Links.User.Profile,
                        text: "Profilim",
                    },
                            ];
                }),                
            });

        return {
            appData,
            Links,
            ...toRefs(e),
        };
        },
    };
</script>

